// extracted by mini-css-extract-plugin
module.exports = {"spaceWrapper":"AmaSalesReportTable_spaceWrapper__2hYYI"};